export default __webpack_public_path__ + "static/media/red-5.6fadbfb9.png";